<!-- 政务角色管理-->
<template>
  <div>
    <x-role v-bind="apiParams"></x-role>
  </div>
</template>

<script>
import { role } from 'ant-design-vue-admin-x';
export default {
  name: 'govRole',
  components: { XRole: role },
  data () {
    return {
      apiParams: {
        listsApi: '/role/govern/list',
        deleteApi: '/role/govern/',
        addApi: '/role/govern',
        editApi: '/role/govern/',
        detailApi: '/role/govern/',
        changeStatusApi: undefined,
        authMenuApi: '/menu/govern/treeselect',
        authMenuByRoleApi: '/menu/roleMenuTreeselect/'
      }
    };
  }
};
</script>
